import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.onFrameLoad = this.onFrameLoad.bind(this)
    this.element.addEventListener("turbo:frame-load", this.onFrameLoad)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.onFrameLoad)
  }

  onFrameLoad() {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" })
  }
}
